import type { Conversation, ConversationReport, Visit } from "./types";

const CONVERSATIONS_KEY = "conversa-smart:local-conversations:v1";
const VISITS_KEY = "conversa-smart:local-visits:v1";
const REPORTS_KEY = "conversa-smart:local-reports:v1";
const ONBOARDING_KEY = "conversa-smart:onboarding-complete:v1";

function readJson<T>(key: string, fallback: T): T {
  if (typeof window === "undefined") return fallback;
  try {
    const value = window.localStorage.getItem(key);
    return value ? (JSON.parse(value) as T) : fallback;
  } catch {
    return fallback;
  }
}

function writeJson<T>(key: string, value: T) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(key, JSON.stringify(value));
}

export function loadLocalConversations() {
  return readJson<Conversation[]>(CONVERSATIONS_KEY, []);
}

export function saveLocalConversations(items: Conversation[]) {
  writeJson(CONVERSATIONS_KEY, items);
}

export function loadLocalVisits() {
  return readJson<Visit[]>(VISITS_KEY, []);
}

export function saveLocalVisits(items: Visit[]) {
  writeJson(VISITS_KEY, items);
}

export function loadLocalReports() {
  return readJson<ConversationReport[]>(REPORTS_KEY, []);
}

export function saveLocalReports(items: ConversationReport[]) {
  writeJson(REPORTS_KEY, items);
}

export function onboardingComplete() {
  return readJson<boolean>(ONBOARDING_KEY, false);
}

export function markOnboardingComplete(value = true) {
  writeJson(ONBOARDING_KEY, value);
}

export function clearLocalWorkspace() {
  if (typeof window === "undefined") return;
  for (const key of [CONVERSATIONS_KEY, VISITS_KEY, REPORTS_KEY, ONBOARDING_KEY]) {
    window.localStorage.removeItem(key);
  }
}
